
import { defineComponent, PropType, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import type { QuitSiteData } from './index';

export default defineComponent({
  name: 'QuitSiteForm',

  components: {
    Button,
  },

  props: {
    modelValue: {
      type: Object as PropType<QuitSiteData>,
      default: () => ({ multiplebox_type: '0' }),
    },
    formValidation: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['update:modelValue', 'cancel', 'close', 'submit'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const localData = ref<QuitSiteData>({ ...props.modelValue });

    const options = [
      {
        value: '0',
        label: t('flows.operators.quitSite.hasQuit'),
        icon: 'far fa-sign-out',
      },
      {
        value: '1',
        label: t('flows.operators.quitSite.isGoingToQuit'),
        icon: 'far fa-hand',
      },
    ];

    watch(localData, (newData) => {
      emit('update:modelValue', newData);
    }, { deep: true });

    watch(() => props.modelValue, (newValue) => {
      if (newValue !== localData.value) {
        localData.value = { ...newValue };
      }
    });

    return {
      t,
      localData,
      options,
    };
  },
});
